import * as React from 'react';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { setMapPreviewOnboardingCookie } from './helpers';
import { useMapPreviewOnboarding } from './hooks';
import { MapPreviewOnboarding } from '../../components/MapPreviewOnboarding';

interface IMapPreviewOnboardingContainerProps {
  children: React.ReactElement<unknown>;
  onClick(event: React.MouseEvent<HTMLElement>): void;
}

export const MapPreviewOnboardingContainer: React.FC<IMapPreviewOnboardingContainerProps> = ({ children, onClick }) => {
  const { isVisible, text, timesShown } = useMapPreviewOnboarding();

  const handleShow = React.useCallback(() => {
    setMapPreviewOnboardingCookie(timesShown + 1);
  }, [timesShown]);

  if (isVisible) {
    return (
      <MapPreviewOnboarding onClick={onClick} text={text}>
        <ActionAfterViewObserver triggerOnce callback={handleShow} percentVisible={1}>
          {children}
        </ActionAfterViewObserver>
      </MapPreviewOnboarding>
    );
  }

  return children;
};
